import React, { useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { getMatches } from '../api';

function Matches() {
  const navigate = useNavigate();
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        const response = await getMatches();
        setMatches(response.data);
      } catch (err) {
        console.error('Error fetching matches:', err);
      }
      setLoading(false);
    };
    fetchMatches();
  }, []);

  if (loading) {
    return (
      <div className="container">
        <div className="hero">
          <p className="auth-eyebrow">✦ Kami Cupid</p>
          <h1 className="auth-title">Your<br />Matches</h1>
          <p className="auth-divider">— ✦ —</p>
          <p className="tagline">Loading your connections...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container" style={{ alignItems: 'flex-start', padding: '40px 20px' }}>
      <div style={{ width: '100%', maxWidth: '600px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '35px' }}>
          <p className="auth-eyebrow">✦ Kami Cupid</p>
          <h1 className="auth-title">Your<br />Matches</h1>
          <p className="auth-divider">— ✦ —</p>
          <p className="tagline">
            {matches.length > 0
              ? `${matches.length} connection(s) waiting for you 💕`
              : 'No matches yet — keep swiping!'}
          </p>
        </div>

        {/* Match List */}
        {matches.length === 0 ? (
          <div style={{ textAlign: 'center' }}>
            <button className="btn-signup" onClick={() => navigate('/swipe')}>
              Start Swiping
            </button>
          </div>
        ) : (
          matches.map((match, index) => (
            <div
              key={match.id}
              className="match-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="match-photo">
                {match.photo ? (
                  <img src={match.photo} alt={match.name} className="match-photo-img" />
                ) : (
                  <span>👤</span>
                )}
              </div>
              <div className="match-info">
                <h3>{match.name}, {match.age}</h3>
                <p>{match.bio || 'No bio yet'}</p>
              </div>
              <button
                className="btn-message"
                onClick={() => navigate('/chat/' + match.id)}
              >
                💬 Message
              </button>
            </div>
          ))
        )}

        {/* Footer */}
        {matches.length > 0 && (
          <button
            className="btn-login"
            style={{ width: '100%', marginTop: '20px' }}
            onClick={() => navigate('/swipe')}
          >
            Keep Swiping
          </button>
        )}
      </div>
    </div>
  );
}

export default Matches;